import React from 'react';

import Card from '../Common/Card';

const ServiceCard = ({ loading, versionSlug, serviceData }) => {

	const {
		serviceCode,
		info: {
			title,
			description
		} = {}
	} = serviceData || {};

	return (
		<Card
			loading={loading}
			title={title}
			description={description}
			target={versionSlug && serviceCode ? `/${versionSlug}/service/${serviceCode}` : ''}
			targetLabel="View docs"
		/>
	);

};

export default ServiceCard;